import { Box } from '@mui/material';
import { AssetDetailGroup } from './groups/AssetDetailGroup';
import { AssetSettingsGroup } from './groups/AssetSettingsGroup';

export const DetailsTab = ({ isDisabled }: { isDisabled: boolean; tenantId: number; assetId?: number }) => (
    <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', pb: '88px', pt: '16px' }}>
        <Box sx={{ flex: 1, mr: 2 }}>
            <AssetSettingsGroup disabled={isDisabled} />
        </Box>
        <Box sx={{ flex: 1, mr: 2 }}>
            <AssetDetailGroup disabled={isDisabled} />
        </Box>
    </Box>
) 